/* eslint-disable */
import validate from 'validate.js'
import api from '../../../api/activity'
import router from '../../../router'

const actions = {

    async getFieldOptions({ commit }) {
        const response = await api.getOptions()
        const finalOptions = {}
        response.data.forEach(option => {
            if (typeof finalOptions[option.option_for] == 'undefined') {
                finalOptions[option.option_for] = []
            }
            finalOptions[option.option_for].push(option)
        })
        commit('setFieldOptions', finalOptions)
    },
    async getWarmupsOptions({ commit }) {
        const response = await api.getWarmups()
        commit('setWarmupsOptions', response.data)
    },
    async getStretchFlowsOptions({ commit }) {
        const response = await api.getStretchFlows()
        commit('setStretchFlowsOptions', response.data)
    },
    openSidebar({ commit, state }) {
        commit('setSidebarOpened', { sidebarOpened: true })
    },
    closeSidebar({ commit }) {
        commit('setSidebarOpened', { sidebarOpened: false })
    },
    // TODO
    async createSeries({ dispatch, commit }, series) {
        const response = await api.createSeries(series)
        await dispatch('getFieldOptions')
        commit(`setActivityField`, {
            fieldName: "series",
            value: response.data.id,
        });
        return response.data
    },
    async createEmptyActivity({ commit, getters, dispatch }, activity) {
        const validationRules = getters['startTabValidationRules']
        const validationResult = validate(activity, validationRules)
        if (validationResult) {
            commit('setStartTabValidation', validationResult)
            return false
        } else {
            commit('setEmptyStartTabValidation')
        }
        try {
            const activityType = activity.type == 'stretch_flow' ? 'stretch-flow' : activity.type
            const response = await api.createEmptyActivity(activity, activityType)
            commit('setActivity', response.data)
            router.push(`/update-${activityType}/${response.data.id}`)
        }
        catch (e) {
            const serverValidationResult = {}
            Object.keys(e.response.data).forEach(key => {
                serverValidationResult[key] = e.response.data[key].join(' ')
            })
            console.log(serverValidationResult, 'serverValidationResult')
            commit('setStartTabValidation', serverValidationResult)
            return serverValidationResult
        }

    },
    // TODO
    async updateActivity({ commit, state, getters }, id) {

        const activity = JSON.parse(JSON.stringify(state.currentActivity))
        if (activity.levels.length > 0) {
            activity.primary_level = activity.levels[0]
        } else {
            activity.primary_level = null
        }

        if (activity.flag_intensity == 0) {
            activity.flag_intensity = 1
        }
        const validationRules = getters['startTabValidationRules']
        const validationResult = validate(activity, validationRules)
        if (validationResult) {
            console.log(validationResult)
            commit('setStartTabValidation', validationResult)
            return false
        } else {
            commit('setEmptyStartTabValidation')
        }

        commit('setSaving', true)
        try {
            const response = await api.updateActivity(id, activity)
            // commit('setActivity', response.data)
            commit('setTabStatus', false)
            commit('setSaving', false)
        }
        catch (e) {
            const serverValidationResult = {}
            Object.keys(e.response.data).forEach(key => {
                serverValidationResult[key] = e.response.data[key].join(' ')
            })
            commit('setStartTabValidation', serverValidationResult)
            commit('setSaving', false)
            return serverValidationResult
        }
    },
    async updateSeries({ commit, state }, activity) {
        const response = await api.updateActivity(activity.id, activity)
        return response.data
    },
    async updateActivityNotes({ commit, state, getters }, id) {

        const activity = JSON.parse(JSON.stringify(state.currentActivity))
        if (activity.flag_intensity == 0) {
            activity.flag_intensity = 1
        }

        try {
            const response = await api.updateActivity(id, activity)
            commit('setActivity', response.data)
            commit('setSaving', false)
        }
        catch (e) {
            commit('setSaving', false)
        }
    },
    async getActivity({ commit, state }, id) {
        const response = await api.getActivity(id, state.currentActivity)
        commit('setActivity', response.data)
    },

    setActivityField({ commit, state, dispatch }, payload) {
        commit("setActivityField", payload)
        dispatch('updateActivity', state.currentActivity.id)
    },

    async getEquipmentsCategories({ commit }) {
        const response = await api.getEquipmentsCategories()
        commit('setEquipmentsCategories', response.data)
    },
    async getEquipment({ commit }, equipment) {
        commit('setEquipment', equipment)
    },
    async getActivities({ commit }) {
        const response = await api.getActivities()
        commit('setActivities', response.data)
    },
    async createSelectedEquipments({ commit, state, dispatch }, equipments) {
        await api.createSelectedEquipments(equipments, state.currentActivity)
        dispatch('getActivity', state.currentActivity.id)
    },
    async deleteSelectedEquipment({ commit, state, dispatch }, id) {
        await api.deleteSelectedEquipment(state.currentActivity, id)
        dispatch('getActivity', state.currentActivity.id)
    },
    async updateProduction({ commit, state }) {

        if (state.currentActivity.pre_production) {
            await api.updateProduction(state.currentActivity, state.currentActivity.pre_production, 'pre-production')
        } else {
            commit('setActivityProductionId', 'pre_production')
            await api.createProduction(state.currentActivity, state.pre_production, 'pre-production')
        }

        if (state.currentActivity.post_production) {
            await api.updateProduction(state.currentActivity, state.currentActivity.post_production, 'post-production')
        } else {
            commit('setActivityProductionId', 'post_production')
            await api.createProduction(state.currentActivity, state.post_production, 'post-production')
        }

        if (state.currentActivity.render) {
            await api.updateProduction(state.currentActivity, state.currentActivity.render, 'render')
        } else {
            commit('setActivityProductionId', 'render')
            await api.createProduction(state.currentActivity, state.render, 'render')
        }

    },

    async updateSpecificProduction({ commit, state }) {
        commit('setActivityProductionId', 'post_production')
        await api.updateProduction(state.currentActivity, state.currentActivity.post_production, 'post-production')
    },

    startTabValidation({ commit, getters, state }, activity) {
        const validationRules = getters['startTabValidationRules']
        const validationResult = validate(activity, validationRules)
        console.log(validationResult, 'validationResult')
        if (validationResult) {
            commit('setStartTabValidation', validationResult)
            return false
        } else {
            commit('setEmptyStartTabValidation')
        }
    },
    musicTabValidation({ commit, getters, state }, activity) {
        const validationRules = getters['MusicTabValidationRules']
        const validationResult = validate(activity, validationRules)
        console.log(validationResult)
        if (validationResult) {
            commit('setMusicTabValidation', validationResult)
            return
        } else {
            commit('setEmptyMusicTabValidation')
        }
    },

    async updateFlag({ commit, state }, id) {
        await api.updateFlag(id, state.updateActivity)
    },
    async listByType({ commit, state }, data) {
        const response = await api.getListByType(data)
        commit('setCurrentList', response.data)
        return response.data
    },

    async getCurrentWarmup({ commit, state }, id) {
        const response = await api.getCurrentWarmup(id)
        commit('setCurrentWarmup', response.data)
    },
    async getCurrentStrechflow({ commit, state }, id) {
        const response = await api.getCurrentStrechflow(id)
        commit('setCurrentStretchFlow', response.data)
    },

    async getCurrentVideos({ commit, state }, id) {
        const response = await api.getCurrentVideos(id, state.currentActivity.type)
        commit('setCurrentVideos', response.data)
    },
    async updateVideo({ commit, state }) {
        state.currentVideos.forEach(value => {
            if (!value.hidden) {
                api.updateVideo(value, state.currentActivity.type)
            }
        })
    },
    async getUsers({ commit, state }) {
        const response = await api.getUsers()
        commit('setUserList', response.data)
    },

    async preloader({ commit }, status) {
        commit('setPreloader', status)
    },
    async getJourney({ commit }) {
        const response = await api.getJourney()
        commit('setJourney', response.data.results)
        return response.data.results
    },
    async getJourneyReport({ commit }, payload) {
        const response = await api.getJourneyReport(payload)
        commit('setJourneyReport', response.data)
    },
}

export default actions
